/* eslint-disable no-unused-vars */
import 'babel-polyfill'

import styles from './styles/main'
import iconstyles from './styles/icon'
import loginstyles from './styles/login'
import modalStyles from './styles/modal'
import objectManagementStyles from './styles/objectmanagement'
import kioskStyles from './styles/kiosk'
import animations from './styles/animations'

import React from 'react'

import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { Router, hashHistory } from 'react-router';

import routes from './routes';
import { createStore, applyMiddleware, compose } from 'redux'
import { loadingEnd, getBlackboxStatus, getUniqueId, log } from './actions/generalActions';
import { getPos } from './actions/dataActions';
import { setFunctionBarType } from './actions/layoutActions';
import { logoutUser } from './actions/loginActions'
import * as types from './constants/Types'

import thunkMiddleware from 'redux-thunk'
import rootReducer from './reducers'
import * as general from './constants/General'

import { signalRStart } from './signalr'

import { startScanner } from './scanner.js'
import $ from 'jquery'

let store;

const localStore = localStorage.getItem('store');

const composeEnhancers =
  typeof window === 'object' &&
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?   
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
    }) : compose;

const enhancer = composeEnhancers(
  applyMiddleware(thunkMiddleware)
);

if (localStore !== null) {
  const persistedStore = JSON.parse(localStore);
  store = createStore(
    rootReducer,
    persistedStore,
    enhancer
  )
} else {
  store = createStore(
    rootReducer,
    enhancer
  )
}

let thisPos;
let isLoading = false;
let isLoadingSet = new Date();
let actionTime = new Date();

setInterval(function setTime() {
  const {
    generalState,
    loginState,
    receiptState
  } = store.getState();

  if (!isLoading && generalState.isLoading) {
    isLoading = true;
    isLoadingSet = new Date();

    //action has been taken
    actionTime = new Date();
  }

  if (isLoading && (isLoadingSet - new Date()) < -60000) {
    store.dispatch(loadingEnd());
    isLoading = false;
  }

  //Auto logout when logged in and TimeOut is not infinite (0)
  if (loginState.loggedin.id != null) {
    if (thisPos == null) {
      thisPos = store.dispatch(getPos(generalState.posId));
      actionTime = new Date();
    }
    else {
      if (thisPos.TimeOut > 0 && (actionTime - new Date()) < - thisPos.TimeOut * 1000) {
        let currentReceipt = receiptState.receipt;
        if (currentReceipt.receiptnumber === null) {

          store.dispatch(setFunctionBarType(general.FUNCTIONBAR_NONE));
          store.dispatch(logoutUser());
          actionTime = new Date();
        }
      }
    }
  }
  else {
    thisPos = null;
  }

  // don't query for blackbox status if we are a production kiosk, order kiosk, ticket scanner or running a customerdisplay
  if (generalState.licenses.blackbox && generalState.hasBlackbox &&
    generalState.posType !== types.POSTYPE_PRODUCTIONKIOSK &&
    generalState.posType !== types.POSTYPE_ORDERKIOSK &&
    generalState.posType !== types.POSTYPE_TICKETSCANNER &&
    !window.location.hash.startsWith('#/customerdisplay')
  ) {
    store.dispatch(getBlackboxStatus(generalState.posId, loginState.loggedin.id));
  }

  return this
}, 1000)

store.subscribe(() => {
  try{
    localStorage.setItem('store', JSON.stringify(store.getState()));
  }
  catch(error){
    console.error(error);
  }
})

store.dispatch(getUniqueId());

signalRStart(store, () => {
  render(
    <Provider store={store}>
      <Router history={hashHistory} routes={routes} />
    </Provider>, document.getElementById('root')
  )
});

// only init when the page has loaded
$(document).ready(function () {
  startScanner(store);

  window.onerror = function (msg, url, line, col, error) {
    try {

      let extra = !col ? '' : '\ncolumn: ' + col;
      extra += !error ? '' : '\nerror: ' + error;
      const errorMessage = "Error: " + msg + "\nurl: " + url + "\nline: " + line + extra;

      store.dispatch(log(errorMessage, true));
    } catch (error) {
      console.log(error);
    }
  };
});



// WEBPACK FOOTER //
// src/index.js